(() => {
  const root = document.querySelector('[data-floating-donate]');
  if (!root) return;
  const messageNode = root.querySelector('[data-floating-donate-message]');
  const donateButton = root.querySelector('.floating-donate__button');
  const donateUrl =
    (donateButton && donateButton.getAttribute('href')) ||
    'https://www.paypal.com/donate/?hosted_button_id=FAJFQC44V7KZS';

  const revealThreshold = 80;
  const bubbleDisplayMs = 14000;
  const sectionHeader = document.querySelector('.section-header');
  const pageType = root.getAttribute('data-page-type') || 'default';
  const messageBankByPageType = {
    index: [
      'Thanks for visiting. If you want to keep the stoke alive, consider donating.',
      'Glad you are here. If this mission speaks to you, consider donating to fuel what comes next.',
      'You made it to the home front. If you want to support the stoke, a donation goes a long way.',
      'Appreciate you stopping by. If you believe in this work, consider donating to back the mission.'
    ],
    product: [
      'Thanks for checking out the gear. If you want to keep the stoke going, consider donating.',
      'If this product speaks to you, you can help power the bigger mission with a donation.',
      'Appreciate you exploring the lineup. Want to support the stoke even more? Consider donating.'
    ],
    collection: [
      'Thanks for browsing the collection. If you want to keep the stoke going, consider donating.',
      'This lineup is mission-driven from top to bottom. If you can, consider donating to support it.',
      'Appreciate you exploring the collection. A donation helps us keep building momentum.'
    ],
    article: [
      'Thanks for reading. If this story moved you, consider donating to keep the stoke alive.',
      'Appreciate your time on this story. If you want to back more like it, consider donating.',
      'If this article resonated, you can help power the mission forward with a donation.'
    ],
    blog: [
      'Thanks for spending time with our stories. If you want to keep the stoke rolling, consider donating.',
      'Glad you are reading along. A donation helps us keep sharing real stories and real impact.',
      'If this blog content is valuable to you, consider donating to support what we are building.'
    ],
    cart: [
      'Thanks for supporting through your order. If you want to push the stoke further, consider donating.',
      'You are almost there. If you can, add even more impact with a quick donation.',
      'Appreciate your checkout support. A donation is another way to keep this mission moving.'
    ],
    page: [
      'Thanks for visiting. If you want to continue supporting the stoke, consider donating.',
      'Appreciate you being here. If this mission matters to you, a donation helps keep it strong.',
      'Glad you stopped in. If you want to back the stoke, consider making a donation.'
    ],
    search: [
      'Hope you found what you were looking for. If you want to keep the stoke alive, consider donating.',
      'Thanks for searching around. A donation helps us keep growing this mission-driven space.',
      'Appreciate you exploring the site. If you can, consider donating to support the work.'
    ],
    default: [
      'Thanks for visiting. If you want to continue supporting the stoke, consider donating.',
      'Appreciate you being here. If this mission resonates with you, consider donating.',
      'Glad you stopped by. If you want to help us keep building, consider making a donation.'
    ]
  };

  let bubbleHasPlayed = false;
  let bubbleTimer = null;
  let selectedMessage = '';

  const escapeHtml = (value) => {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    return String(value).replace(/[&<>"']/g, (match) => map[match]);
  };

  const setMessage = (message) => {
    if (!messageNode) return;
    messageNode.innerHTML = `${escapeHtml(message)} <a class="floating-donate__message-link" href="${escapeHtml(
      donateUrl
    )}" target="_blank" rel="noopener noreferrer">donate here</a>.`;
  };

  const pickMessage = () => {
    const pool = messageBankByPageType[pageType] || messageBankByPageType.default;
    if (!pool || !pool.length) {
      return 'Thanks for visiting. If you want to continue supporting the stoke, consider donating.';
    }
    return pool[Math.floor(Math.random() * pool.length)];
  };

  const updateVisibility = () => {
    const hasScrolled = window.scrollY > revealThreshold;
    const headerHidden = sectionHeader && sectionHeader.classList.contains('shopify-section-header-hidden');
    const scrolledPastHeader = sectionHeader && sectionHeader.classList.contains('scrolled-past-header');
    const shouldShow = hasScrolled || headerHidden || scrolledPastHeader;

    root.classList.toggle('is-visible', shouldShow);

    if (!shouldShow) {
      root.classList.remove('is-bubble-visible');
      if (bubbleTimer) {
        window.clearTimeout(bubbleTimer);
        bubbleTimer = null;
      }
      return;
    }

    if (!bubbleHasPlayed) {
      root.classList.add('is-bubble-visible');
      selectedMessage = pickMessage();
      setMessage(selectedMessage);
      bubbleHasPlayed = true;
      bubbleTimer = window.setTimeout(() => {
        root.classList.remove('is-bubble-visible');
      }, bubbleDisplayMs);
    }
  };

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);
  document.addEventListener('shopify:section:reorder', updateVisibility);
  document.addEventListener('shopify:section:load', updateVisibility);
  root.addEventListener('click', (event) => {
    if (event.target.closest('a')) return;
    window.open(donateUrl, '_blank', 'noopener,noreferrer');
  });

  updateVisibility();
})();
